import { BuyPlanPagePrismicDocument } from '../prismic/BuyPlanPagePrismicDocument'
import { PlanType } from '@dtx-company/true-common/src/types/planType'

export const buyPlanPagePrismicDocuments: Record<PlanType, BuyPlanPagePrismicDocument | null> = {
  [PlanType.FREE]: null,
  [PlanType.PRO]: {
    id: 'ZMFHMREAACEALzPZ',
    uid: 'buy-pro-plan-page',
    url: null,
    type: 'buy_plan_page',
    href: 'https://flowcode-ui.cdn.prismic.io/api/v2/documents/search?ref=ZnR8HREAACUAlhmw&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22ZMFHMREAACEALzPZ%22%29+%5D%5D',
    tags: [],
    first_publication_date: '2023-07-26T17:05:37+0000',
    last_publication_date: '2024-01-29T04:48:25+0000',
    slugs: [
      'upgrade-to--plantypename-',
      'unlock--plantypename-',
      'unlock--plantypenames-',
      'upgrade-to-pro--plantypename--downcase-',
      'upgrade-to-pro',
      'pro',
      'unlock-pro2',
      'unlock-pro'
    ],
    linked_documents: [],
    lang: 'en-us',
    alternate_languages: [],
    data: {
      page_heading: 'Upgrade to {{ planTypeName }}',
      purchase_cta: 'Purchase',
      success_snackbar_text: 'Thanks for buying {{ planTypeName }}!',
      payment_heading: 'Payment details',
      secure_form_label: 'Secure form',
      change_existing_payment_button: undefined,
      payment_incomplete_message: 'Please ensure your entire payment method is filled out above.',
      promo_code_dropdown_button: 'Do you have a discount code?',
      promo_code_input_label: 'Discount code',
      promo_code_input_button_label: 'Apply',
      promo_code_error: 'Invalid promo code',
      promo_code_wrong_plan_error: 'Invalid promo code for selected plan',
      summary_heading: 'Summary',
      plan_label: '{{ planTypeName }} Plan',
      currency_abbreviation: 'USD',
      billed_annually_label: 'Billed annually ($5/month)',
      billed_monthly_label: 'Billed monthly ($15/month)',
      plan_details_label: 'Plan details',
      plan_details: [
        {
          label: 'Up to {{ planFlowcodeLimit }} Flowcodes',
          tooltip:
            'Flowcode QR codes are all dynamic, so the destinations they scan to can always be edited.',
          description:
            'Flowcode QR codes are all dynamic, so the destinations they scan to can always be edited.',
          tooltip_heap_key: 'flowcode_limit_tooltip',
          description_heap_key: 'flowcode_limit_description'
        },
        {
          label: 'Up to {{ planFlowpageLimit }} Flowpages',
          tooltip:
            'Flowpages are easy to create mobile landing pages that serve as ideal scan destinations for your flowcodes.',
          description:
            'Flowpages are easy to create mobile landing pages that serve as ideal scan destinations for your flowcodes.',
          tooltip_heap_key: 'flowpage_limit_tooltip',
          description_heap_key: 'flowpage_limit_description'
        },
        {
          label: 'Smart Routing',
          tooltip:
            'Automatically redirect people who scan your code to different destinations based on conditions you set like time of day and device type.',
          description:
            'Automatically redirect people who scan your code to different destinations based on conditions you set like time of day and device type.',
          tooltip_heap_key: 'smart_routing_tooltip',
          description_heap_key: 'smart_routing_description'
        },
        {
          label: 'Hex colors',
          tooltip: 'Select colors for your flowcode QR codes and flowpages that match your brand.',
          description:
            'Select colors for your flowcode QR codes and flowpages that match your brand.',
          tooltip_heap_key: 'hex_colors_tooltip',
          description_heap_key: 'hex_colors_description'
        }
      ],
      base_price_label: 'Base price',
      annual_discount_label: 'Annual savings',
      promo_code_label: 'Discount',
      proration_label: 'Price adjustment from old plan to new',
      credits_label: 'Credits applied',
      additional_seats_label: undefined,
      grand_total_label: 'Billed now',
      sales_tax_text: 'Plus applicable sales tax',
      org_name_heading: undefined,
      org_name_description: undefined,
      org_name_label: undefined,
      org_name_required: undefined,
      org_name_min_max_length: undefined,
      additional_seats_heading: undefined
    }
  },
  [PlanType.PRO_PLUS_ORG]: {
    id: 'ZQC3xxEAACIA7OKu',
    uid: 'buy-pro-plus-plan-page',
    url: null,
    type: 'buy_plan_page',
    href: 'https://flowcode-ui.cdn.prismic.io/api/v2/documents/search?ref=ZnR8HREAACUAlhmw&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22ZQC3xxEAACIA7OKu%22%29+%5D%5D',
    tags: [],
    first_publication_date: '2023-09-12T19:21:49+0000',
    last_publication_date: '2023-10-02T20:17:31+0000',
    slugs: ['upgrade-to--plantypename-'],
    linked_documents: [],
    lang: 'en-us',
    alternate_languages: [],
    data: {
      page_heading: 'Upgrade to {{ planTypeName }}',
      purchase_cta: 'Purchase',
      success_snackbar_text: 'Thanks for buying {{ planTypeName }}!',
      payment_heading: 'Payment details',
      secure_form_label: 'Secure form',
      change_existing_payment_button: 'Edit',
      payment_incomplete_message: 'Please ensure your entire payment method is filled out above.',
      promo_code_dropdown_button: 'Do you have a discount code?',
      promo_code_input_label: 'Discount code',
      promo_code_input_button_label: 'Apply',
      promo_code_error: 'Invalid promo code',
      promo_code_wrong_plan_error: 'Invalid promo code for selected plan',
      summary_heading: 'Summary',
      plan_label: '{{ planTypeName }} Plan',
      currency_abbreviation: 'USD',
      billed_annually_label: 'Billed annually',
      billed_monthly_label: 'Billed monthly',
      plan_details_label: 'Plan details',
      plan_details: [
        {
          label: 'Up to {{ planFlowcodeLimit }} Flowcodes',
          tooltip:
            'Flowcode QR codes are all dynamic, so the destinations they scan to can always be edited.',
          description:
            'Flowcode QR codes are all dynamic, so the destinations they scan to can always be edited.',
          tooltip_heap_key: 'flowcode_limit_tooltip',
          description_heap_key: 'flowcode_limit_description'
        },
        {
          label: 'Up to {{ planFlowpageLimit }} Flowpages',
          tooltip:
            'Flowpages are easy to create mobile landing pages that serve as ideal scan destinations for your flowcodes.',
          description:
            'Flowpages are easy to create mobile landing pages that serve as ideal scan destinations for your flowcodes.',
          tooltip_heap_key: 'flowpage_limit_tooltip',
          description_heap_key: 'flowpage_limit_description'
        },
        {
          label: 'Smart Routing',
          tooltip:
            'Automatically redirect people who scan your code to different destinations based on conditions you set like time of day and device type.',
          description:
            'Automatically redirect people who scan your code to different destinations based on conditions you set like time of day and device type.',
          tooltip_heap_key: 'smart_routing_tooltip',
          description_heap_key: 'smart_routing_description'
        },
        {
          label: 'Hex colors',
          tooltip: 'Select colors for your flowcode QR codes and flowpages that match your brand.',
          description:
            'Select colors for your flowcode QR codes and flowpages that match your brand.',
          tooltip_heap_key: 'hex_colors_tooltip',
          description_heap_key: 'hex_colors_description'
        }
      ],
      base_price_label: 'Base price',
      annual_discount_label: 'Annual savings',
      promo_code_label: 'Discount',
      proration_label: 'Price adjustment from old plan to new',
      credits_label: 'Credits applied',
      additional_seats_label: 'Additional seats:',
      grand_total_label: 'Billed now',
      sales_tax_text: 'Plus applicable sales tax',
      org_name_description: 'This is the name others in your group will see when collaborating.',
      org_name_label: 'Organization name',
      org_name_required: 'organization name is required',
      org_name_min_max_length: 'name must be between 3 and 64 characters long',
      additional_seats_heading: 'Number of seats'
    }
  },
  [PlanType.PRO_FLEX]: {
    id: 'ZQC9NBEAACIA7Pqy',
    uid: 'buy-pro-flex-plan-page',
    url: null,
    type: 'buy_plan_page',
    href: 'https://flowcode-ui.cdn.prismic.io/api/v2/documents/search?ref=ZnR8HREAACUAlhmw&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22ZQC9NBEAACIA7Pqy%22%29+%5D%5D',
    tags: [],
    first_publication_date: '2023-09-12T19:34:44+0000',
    last_publication_date: '2024-03-07T17:22:24+0000',
    slugs: ['upgrade-to--plantypename-'],
    linked_documents: [],
    lang: 'en-us',
    alternate_languages: [],
    data: {
      page_heading: 'Upgrade to {{ planTypeName }}',
      purchase_cta: 'Purchase',
      success_snackbar_text: 'Thanks for buying {{ planTypeName }}!',
      payment_heading: 'Payment details',
      secure_form_label: 'Secure form',
      change_existing_payment_button: 'Edit',
      payment_incomplete_message: 'Please ensure your entire payment method is filled out above.',
      promo_code_dropdown_button: 'Do you have a discount code?',
      promo_code_input_label: 'Discount code',
      promo_code_input_button_label: 'Apply',
      promo_code_error: 'Invalid promo code',
      promo_code_wrong_plan_error: 'Invalid promo code for selected plan',
      summary_heading: 'Summary',
      plan_label: '{{ planTypeName }} Plan',
      currency_abbreviation: 'USD',
      billed_annually_label: 'Billed annually',
      billed_monthly_label: 'Billed monthly',
      plan_details_label: 'Plan details',
      plan_details: [
        {
          label: 'Starts at 150 Flowcodes',
          tooltip:
            'Flowcode QR codes are all dynamic, so the destinations they scan to can always be edited.',
          description:
            'Flowcode QR codes are all dynamic, so the destinations they scan to can always be edited.',
          tooltip_heap_key: 'flowcode_limit_tooltip',
          description_heap_key: 'flowcode_limit_description'
        },
        {
          label: 'Starts at 150 Flowpages',
          tooltip:
            'Flowpages are easy to create mobile landing pages that serve as ideal scan destinations for your flowcodes.',
          description:
            'Flowpages are easy to create mobile landing pages that serve as ideal scan destinations for your flowcodes.',
          tooltip_heap_key: 'flowpage_limit_tooltip',
          description_heap_key: 'flowpage_limit_description'
        },
        {
          label: 'Smart Routing',
          tooltip:
            'Automatically redirect people who scan your code to different destinations based on conditions you set like time of day and device type.',
          description:
            'Automatically redirect people who scan your code to different destinations based on conditions you set like time of day and device type.',
          tooltip_heap_key: 'smart_routing_tooltip',
          description_heap_key: 'smart_routing_description'
        },
        {
          label: 'Hex colors',
          tooltip: 'Select colors for your flowcode QR codes and flowpages that match your brand.',
          description:
            'Select colors for your flowcode QR codes and flowpages that match your brand.',
          tooltip_heap_key: 'hex_colors_tooltip',
          description_heap_key: 'hex_colors_description'
        }
      ],
      base_price_label: 'Base price',
      annual_discount_label: 'Annual savings',
      promo_code_label: 'Discount',
      proration_label: 'Price adjustment from old plan to new',
      credits_label: 'Credits applied',
      additional_seats_label: 'Additional seats:',
      grand_total_label: 'Billed now',
      sales_tax_text: 'Plus applicable sales tax',
      org_name_description: 'This is the name others in your group will see when collaborating.',
      org_name_label: 'Organization name',
      org_name_required: 'organization name is required',
      org_name_min_max_length: 'name must be between 3 and 64 characters long',
      additional_seats_heading: 'Number of seats'
    }
  },
  [PlanType.PILOT]: null,
  [PlanType.ENTERPRISE]: null
}
